import {combineReducers} from 'redux';
import options from './options.reducer';
import extras from './extras.reducer';
import productTypes from './productTypes.reducer';
import promotions from './promotions.reducer';


const menu=combineReducers({
    options,
    extras,
    productTypes,
    promotions,
});

export default menu